import styled from 'styled-components'

/**
 * 对录入类组件颜色进行调整 - 背景色|边框颜色|文字颜色
 *
 * @param props - 参数
 * @returns 样式
 */
export const EntryComponentsWrapper = styled.div`
  &&& {
    /* 默认状态 */
    .ant-input,
    .ant-select,
    .ant-select-selector,
    .ant-picker,
    .ant-input-affix-wrapper,
    .ant-input-group-addon,
    .ant-input-number,
    .ant-input-number-group-addon,
    .ant-input-group,
    .ant-picker-clear,
    .ant-select-clear,
    .ant-input-password {
      border-radius: 8px;
      border: 1px solid transparent !important;
      background-color: ${(props) => props.theme.background._3} !important;
    }
    .ant-input-password {
      padding: 0 0;

      & > input {
        padding-left: 12px;
      }
      & > .ant-input-suffix {
        padding: 0 8px;
      }
    }
    .ant-input-group {
      border: 1px solid transparent;
      & .ant-input {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border: 1px solid transparent !important;
      }
      & .ant-input-group-addon {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        color: ${(props) => props.theme.text._1} !important;
      }
    }
    .ant-input-number-group {
      border: 1px solid transparent;
      & .ant-input-number-input,
      .ant-input-number {
        border-top-right-radius: 0 !important;
        border-bottom-right-radius: 0 !important;
        border: 1px solid transparent !important;
      }
      & .ant-input-number-group-addon {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
    .ant-input-number-handler-wrap {
      border-radius: 8px !important;
    }
    .ant-input-number-handler-up {
      border-top-right-radius: 8px;
    }
    .ant-input-number-handler-down {
      border-bottom-right-radius: 8px;
    }
    .ant-select-multiple .ant-select-selection-item-content {
      color: ${(props) => props.theme.text._1};
    }
    .ant-select-arrow svg,
    .anticon-calendar svg,
    .anticon-clock-circle svg,
    .ant-input-number-handler svg {
      fill: ${(props) => props.theme.text._2} !important;
    }

    .ant-select-disabled.ant-select:not(.ant-select-customize-input)
      .ant-select-arrow
      svg,
    .ant-select-multiple.ant-select-disabled.ant-select:not(
        .ant-select-customize-input
      )
      .ant-select-arrow
      svg,
    .ant-picker-disabled svg,
    .ant-input-disabled .ant-input-number-handler svg {
      fill: ${(props) => props.theme.text._4};
    }
    .ant-form-item-explain-error {
      font-size: 12px;
    }
    .ant-radio-wrapper {
      & span {
        color: ${(props) => props.theme.text._1};
      }
    }
    .ant-picker-ok {
      .ant-btn-primary {
        background-color: ${(props) => props.theme.brand._1};
        border-color: ${(props) => props.theme.brand._1};
      }
    }

    .ant-select-multiple .ant-select-selection-item {
      background-color: #fff !important;
    }

    /* 悬停状态 */
    .ant-input:hover,
    .ant-input-password:hover,
    .ant-input-group:hover .ant-input-group-addon,
    .ant-input-group:hover .ant-input-affix-wrapper,
    .ant-input-affix-wrapper:hover .ant-input,
    .ant-input-number:hover:not(.ant-input-number-focused),
    .ant-input-number:hover:not(.ant-input-number-focused)
      .ant-input-number-handler,
    .ant-input-number-group:hover .ant-input-number-group-addon,
    .ant-select-selector:hover,
    .ant-picker:not(.ant-picker-disabled):hover
      .ant-select:not(.ant-select-disabled):hover
      .ant-select-clear:not(.ant-select-customize-input)
      > .anticon-close-circle,
    .ant-picker:not(.ant-picker-disabled):hover
      .ant-picker-clear:not(.ant-picker-custom-icon)
      > .anticon-close-circle {
      background-color: ${(props) => props.theme.background._2} !important;
      border: 1px solid transparent;
    }

    /* 禁用状态 */
    .ant-input-disabled,
    .ant-input-disabled:hover,
    .ant-select-disabled.ant-select:not(.ant-select-customize-input)
      .ant-select-selector,
    .ant-select-multiple.ant-select-disabled.ant-select:not(
        .ant-select-customize-input
      )
      .ant-select-selector,
    .ant-select-disabled.ant-select:not(.ant-select-customize-input)
      .ant-select-selector:hover,
    .ant-select-multiple.ant-select-disabled.ant-select:not(
        .ant-select-customize-input
      )
      .ant-select-selector:hover,
    .ant-picker-disabled,
    .ant-picker-disabled:hover,
    .ant-picker[disabled]:hover {
      background-color: ${(props) => props.theme.background._3} !important;
      color: ${(props) => props.theme.text._4} !important;
      border: 1px solid transparent !important;
    }

    .ant-input-disabled,
    .ant-select-disabled,
    .ant-picker-disabled,
    .ant-upload-disabled,
    .ant-input-group-addon,
    .ant-select-disabled .ant-select-selection-item,
    .ant-input-number-disabled,
    .ant-picker-disabled input {
      color: ${(props) => props.theme.text._4} !important;
    }

    /* 聚焦状态 */
    .ant-input:not(
        .ant-input-group .ant-input,
        .ant-input-password .ant-input
      ):focus,
    .ant-input-number-focused,
    .ant-select-open .ant-select-selector,
    .ant-picker-focused {
      background-color: ${(props) => props.theme.background._5} !important;
      border: 1px solid ${(props) => props.theme.brand._1} !important;
      color: ${(props) => props.theme.text._1};
    }
    .ant-input-number-focused .ant-input-number-handler {
      background-color: ${(props) => props.theme.background._5};
    }
    .ant-input-group:focus-within {
      border: 1px solid ${(props) => props.theme.brand._1} !important;
      & .ant-input,
      .ant-input-group-addon,
      .ant-input-affix-wrapper {
        background-color: ${(props) => props.theme.background._5} !important;
      }
    }
    .ant-input-number-group:focus-within {
      border: 1px solid ${(props) => props.theme.brand._1} !important;
      border-radius: 8px;
      & .ant-input-number,
      .ant-input-number-group-addon {
        background-color: ${(props) => props.theme.background._5} !important;
      }
    }

    .ant-input-password:focus-within {
      border: 1px solid ${(props) => props.theme.brand._1} !important;
      background-color: ${(props) => props.theme.background._5} !important;

      & .ant-input {
        background-color: ${(props) => props.theme.background._5} !important;
      }
    }
  }
`
